import { render, staticRenderFns } from "./ChallengeInfoPopup.vue?vue&type=template&id=c5c7bcca"
import script from "./ChallengeInfoPopup.vue?vue&type=script&lang=js"
export * from "./ChallengeInfoPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports